import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function AttendanceStaffReport() {
  const location = useLocation();
  const { adminmob, branchId } = location.state || {};
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [attendanceData, setAttendanceData] = useState({});
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [schoolData, setSchoolData] = useState(null); 
  const [presentCountMap, setPresentCountMap] = useState({});
  const navigate = useNavigate();
  const [halfDayCountMap, setHalfDayCountMap] = useState({});
  const [presentDayMap, setPresentDayMap] = useState({});
  const [halfDayCountMap1, sethalfDayCountMap1] = useState({});
  const [weekOffCountMap, setWeekOffCountMap] = useState({});
  const [weekoffCountValue, setWeekoffCountValue] = useState(0);
  const [weekOffDaysCount, setWeekOffDaysCount] = useState(0);
  const [presentCountValue, setPresentCountValue] = useState(0);
  const [halfDayCountValue, setHalfDayCountValue] = useState(0);
  const [absentCountValue, setAbsentCountValue] = useState(0);
  const [absentDayMap, setAbsentDayMap] = useState({});
  const [weekOffDates, setWeekOffDates] = useState([]);
  const [absentdates, setabsentdates] = useState([]);
const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

      useEffect(() => {
                 const storedLanguage = localStorage.getItem('language') || 'English';
                 setLanguage(storedLanguage);
               }, []);
  console.log("branchId",branchId);
  
  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      console.log("aaa");
      
      if (branchId) {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData.json`;
        console.log("url",url);
        
        try {
          const response = await fetch(url);
          const data = await response.json();
          console.log("Data", data); // Log the data to the console
          if (data) {
            const employees = await Promise.all(
              Object.keys(data).map(async (mobile) => {
                // Fetch the Address for each employee
                const addressUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${mobile}/Personaldetails/Address.json`;
                console.log("addressUrl", addressUrl); // Log the addressUrl before making the fetch request
                try {
                  const addressResponse = await fetch(addressUrl);
                  const addressData = await addressResponse.json();
                  return {
                    mobile: data[mobile].Mobno || '-', // Use Mobno for mobile
                    name: data[mobile].Name || '-', // Use Name for name
                    address: addressData || '-', // Use '-' if address is not available
                  };
                } catch (error) {
                  console.error('Error fetching address:', error);
                  return {
                    mobile: data[mobile].Mobno || '-', // Use Mobno for mobile
                    name: data[mobile].Name || '-', // Use Name for name
                    address: '-', // Use '-' if address is not available
                  };
                }
              })
            );
            console.log("Employees", employees); // Log the employees to the console
            setEmployeeDetails(employees);
            
            // Fetch the PunchTimings data
            const punchTimingsUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${employees[0].mobile}/PunchTimings.json`;
            console.log("punchTimingsUrl",punchTimingsUrl);
            
            fetch(punchTimingsUrl)
              .then(response => response.json())
              .then(data => {
                console.log(data);
                const punchTimings = data;
                console.log("punchTimingsssss",punchTimings);
                
                const weekOffDays = Object.keys(punchTimings).filter(key => punchTimings[key] === "All undefineds Week Off");
                console.log("weekOffDays",weekOffDays);
                
                // Set the weekOffDays value to a variable
                const weekOffDayValue = weekOffDays[0].split('-')[0];
                console.log("weekOffDayValue",weekOffDayValue);
                
                // Set the weekOffDayValue to a state variable
                setWeekOffDayValue(weekOffDayValue);
              })
              .catch(error => {
                console.error(error);
              });
          }
        } catch (error) {
          console.error('Error fetching employee details:', error);
        }
      }
    };
    fetchEmployeeDetails();
  }, [ branchId]);


  useEffect(() => {
    const fetchAttendanceData = async () => {
      if (branchId) {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${branchId}/AttData.json`;
        try {
          const response = await fetch(url);
          const data = await response.json();
          if (data) {
            const attendanceArray = Object.keys(data).map(key => ({
              mobile: key,
              name: data[key].Name,
            }));
            setAttendanceData(attendanceArray);
          }
        } catch (error) {
          console.error('Error fetching attendance data:', error);
        }
      }
    };
    fetchAttendanceData();
  }, [branchId]);



  useEffect(() => {
    const fetchWeekOffData = async () => {
      
      if (employeeDetails.length > 0) {
        const weekOffUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${employeeDetails[0].mobile}/PunchTimings.json`;
        console.log("weekOffUrl", weekOffUrl);
        try {
          const response = await fetch(weekOffUrl);
          if (response.ok) {
            const data = await response.json();
            setWeekOffCountMap(data); // Set the fetched week off data
  
            const [year, month] = selectedMonth.split('-');
            let weekOffDaysUntilToday = 0;
            const daysInMonth = new Date(year, month, 0).getDate();
  
            Object.keys(data).forEach((key) => {
              if (data[key] === "All undefineds Week Off") {
                for (let i = 1; i <= daysInMonth; i++) {
                  const date = new Date(year, month - 1, i);
                  const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' });
  
                  if (dayOfWeek === key && date <= new Date()) {
                    weekOffDaysUntilToday++;
                  }
                }
              }
            });
  
            let weekOffCount = 0;
            Object.keys(data).forEach((key) => {
              if (data[key] === "All undefineds Week Off") {
                const daysInMonth = new Date(year, month, 0).getDate();
                for (let i = 1; i <= daysInMonth; i++) {
                  const date = new Date(year, month - 1, i);
                  const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' });
  
                  if (dayOfWeek === key) {
                    weekOffCount++;
                  }
                }
              }
            });
  
            setWeekOffCountMap(weekOffCount);
  
            setWeekOffDaysCount(weekOffDaysUntilToday);
            console.log("Week Off Days Until Today:", weekOffDaysUntilToday);
          } else {
            console.error("Failed to fetch week off data:", response.statusText);
          }
        } catch (error) {
          console.error("Error fetching week off data:", error);
        }
      }
    };
  
    fetchWeekOffData();
  }, [udiseNumber, selectedMonth]);

  const fetchAttendanceDataForMonth = async () => {
    if (employeeDetails.length > 0) {
      const attendanceUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${employeeDetails[0].mobile}/Attendance.json`;
      console.log("weekoffCountValue", weekoffCountValue);
      console.log("weekOffDaysCount", weekOffDaysCount);
  
      try {
        const attendanceResponse = await fetch(attendanceUrl);
        if (attendanceResponse.ok) {
          const attendanceData = await attendanceResponse.json();
          if (attendanceData) {
            let presentCount = 0;
            let halfDayCount = 0;
            let totalDays = 0;
            // Get the selected month and year
            const [year, month] = selectedMonth.split('-');
  
            // Calculate total number of days in the selected month
            const daysInMonth = new Date(year, month, 0).getDate();
            totalDays = daysInMonth;
  
            // Loop through attendance records
            for (const [date, details] of Object.entries(attendanceData)) {
              if (details && details.status) {
                const recordDate = new Date(date);
                const recordYear = recordDate.getFullYear();
                const recordMonth = recordDate.getMonth() + 1;
  
                if (recordYear === parseInt(year) && recordMonth === parseInt(month)) {
                  if (details.status === "Full") {
                    presentCount++;
                  } else if (details.status === "Half") {
                    halfDayCount++;
                  }
                }
              }
            }
  
            // Calculate absent count
            const currentDate = new Date().getDate();
            let remainingDays = 0;
  
           
            const formattedMonth = String(month).padStart(2, '0');
            const formattedCurrentMonth = String(new Date().getMonth() + 1).padStart(2, '0');
  
            let weekOffDaysUntilToday = 0;

            if (formattedMonth === formattedCurrentMonth) {
              const currentDate = new Date().getDate();
              const daysInMonth = new Date(year, month, 0).getDate();
              for (let i = 1; i <= currentDate; i++) {
                const date = new Date(year, month - 1, i);
                const dayOfWeek = date.toLocaleString('en-US', { weekday: 'long' });
                if (dayOfWeek === weekOffDayValue && date <= new Date()) {
                  weekOffDaysUntilToday++;
                }
              }
            }
          
            if (formattedMonth === formattedCurrentMonth) {
              const absentDays = absentdates.length;
              const absentDaysMinusWeekOff = absentDays - weekOffDaysUntilToday - presentCount - halfDayCount;
              // setAbsentCountValue(absentDaysMinusWeekOff);
            } else {
              const absentDays = absentdates.length;
              const absentDaysMinusWeekOff = absentDays - weekOffDaysCount - presentCount - halfDayCount;
              // setAbsentCountValue(absentDaysMinusWeekOff);
            }

            console.log(
              "totalDays",
              totalDays,
              " ,",
              "currentDate",
              currentDate,
              " , ",
              "remainingDays",
              remainingDays,
              ", ",
              "presentCount",
              presentCount,
              ", ",
              "halfDayCount",
              halfDayCount,
              "  , ",
              "weekoffCountValue",
              weekoffCountValue,
              " , ",
              "weekOffDaysCount",
              weekOffDaysCount
            );
  
            let absentCount = 0;
            let absentDates = [];

const weekOffDatesFormatted = weekOffDates.map(day => {
  return `${year}-${month}-${String(day).padStart(2, '0')}`; // Format to YYYY-MM-DD
});
console.log("weekOffDatesFormatted",weekOffDatesFormatted);


// weekOffDates
            if (formattedMonth === formattedCurrentMonth) {
              absentCount = remainingDays;
              for (let i = 1; i <= currentDate; i++) {
                const date = new Date(year, month - 1, i);
                // const formattedDate = `${year}-${month}-${String(i).padStart(2, '0')}`;
                const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(i).padStart(2, '0')}`;
                
                if (!attendanceData[formattedDate] || attendanceData[formattedDate].status !== "Full" && attendanceData[formattedDate].status !== "Half") {
                  if (!weekOffDates.includes(i)) {
                    absentDates.push(formattedDate);
                  }
                }
              }
            } else {
             absentCount = totalDays - presentCount - halfDayCount - weekOffDaysCount;
              for (let i = 1; i <= totalDays; i++) {
                const date = new Date(year, month - 1, i);
                const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(i).padStart(2, '0')}`;
                
                if (!attendanceData[formattedDate] || (attendanceData[formattedDate].status !== "Full" && attendanceData[formattedDate].status !== "Half")) {
                  if (!weekOffDatesFormatted.includes(formattedDate)) {
                    absentDates.push(formattedDate);
                  }
                }
              }
            }
            setabsentdates(absentDates) 
console.log("absentdates",absentdates, " - ", "weekOffDates",weekOffDates);
// const abcount = absentdates.filter((adate) => {
//   const dayOfMonth = parseInt(adate.split('-')[2]);
//   return !weekOffDates.includes(dayOfMonth);
// }).length;
// setAbsentCountValue(abcount)

  
            setPresentCountValue(presentCount);
            setHalfDayCountValue(halfDayCount);
          } else {
            console.log("No attendance records found or data is null");
          }
        } else {
          console.error("Failed to fetch attendance data:", attendanceResponse.statusText);
        }
      } catch (error) {
        console.error("Error fetching attendance data:", error);
      }
    }
  };

  const [weekOffDayValue, setWeekOffDayValue] = useState('');

  useEffect(() => {
    if (selectedMonth) {
      const abcount = absentdates.filter(adate => !weekOffDates.includes(parseInt(adate.split('-')[2]))).length;
      setAbsentCountValue(abcount);
    }
  }, [selectedMonth, absentdates, weekOffDates]);

  useEffect(() => {
          fetchSchoolData(); 
        },[udiseNumber] );
  
        const handleMonthChange = async (event) => {
          const selectedDate = event.target.value;
          setSelectedMonth(selectedDate);
          console.log("selectedDate", selectedDate);
          console.log("branchId", branchId);
        
          if (selectedDate && branchId) {
            const attendancePromises = employeeDetails.map(async (employee) => {
              const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${employee.mobile}/Attendance.json`;
              console.log("atturl", url);
        
              try {
                const response = await fetch(url);
                const data = await response.json();
                console.log("data", data);
        
                return { mobile: employee.mobile, data };
              } catch (error) {
                console.error('Error fetching attendance data:', error);
                return { mobile: employee.mobile, data: {} }; // Return an empty object in case of error
              }
            });
        
            const attendanceResults = await Promise.all(attendancePromises);
            const attendanceDataMap = attendanceResults.reduce((acc, result) => {
              acc[result.mobile] = result.data || {}; // Ensure the data is not null
              return acc;
            }, {});
            
            console.log('Attendance Data Map:', attendanceDataMap);
        
            const presentCountMap = {}; // Store the count of "Full" days
            const halfDayCountMap = {}; // Store the count of "Half" days
            const presentDayMap = {}; // Store the dates of "Present" days
            const halfDayCountMap1 = {}; // Store the count of "Half" days as separate map
            const weekOffCountMap = {}; // Store the count of "Week Off" days
            const absentDayMap = {}; // Store the absent days
        
            const selectedMonth = selectedDate.split('-')[1]; // Extract month from selectedDate
            const selectedYear = selectedDate.split('-')[0]; // Extract year from selectedDate
        
            // Calculate week off dates for the selected month
            const weekOffDay = weekOffDayValue; // Replace with the actual week off day
            const firstDayOfMonth = new Date(selectedYear + '-' + selectedMonth + '-01');
            const weekOffDates = [];
            for (let i = 0; i < 31; i++) {
              const date = new Date(firstDayOfMonth.getTime() + i * 24 * 60 * 60 * 1000);
              if (date.getMonth() === firstDayOfMonth.getMonth() && date.toLocaleString('en-US', { weekday: 'long' }) === weekOffDay) {
                weekOffDates.push(date.getDate());
              }
            }
        
            console.log('Week Off Dates:', weekOffDates);
        
            setWeekOffDates(weekOffDates);
        
            // Iterate through the attendance data to calculate counts
            Object.keys(attendanceDataMap).forEach((mobile) => {
              const attendanceData = attendanceDataMap[mobile];
              const punchTimings = attendanceData?.PunchTimings; // Assuming PunchTimings is inside attendance data
              console.log("punchTimings",punchTimings);
              
              if (punchTimings && typeof punchTimings === 'object') {
                // Calculate week off day count for the selected month
                const weekOffCount = Object.keys(punchTimings).filter((day) => {
                  console.log("weekOffCount",weekOffCount);
                  
                  const dateMonth = day.split('-')[1]; // Extract month from date
                  const dateYear = day.split('-')[0]; // Extract year from date
        
                  // Only check for the selected month and year
                  if (dateYear === selectedYear && dateMonth === selectedMonth) {
                    // Check if the value is "All undefineds Week Off"
                    return punchTimings[day] === "All undefineds Week Off";
                  }
                  return false;
                }).length;
        
                weekOffCountMap[mobile] = weekOffCount; // Store the count of "Week Off" days for the employee
        
                // Get the week off dates for the selected month
                const weekOffDatesForMonth = Object.keys(punchTimings).filter((day) => {
                  const dateMonth = day.split('-')[1]; // Extract month from date
                  const dateYear = day.split('-')[0]; // Extract year from date
        
                  // Only check for the selected month and year
                  if (dateYear === selectedYear && dateMonth === selectedMonth) {
                    // Check if the value is "All undefineds Week Off"
                    return punchTimings[day] === "All undefineds Week Off";
                  }
                  return false;
                });
        
                console.log(`Week Off dates for mobile ${mobile} in month ${selectedMonth}: ${weekOffDatesForMonth.join(', ')}`);
        
                // Update the week off dates in the attendance data
                attendanceData.wdate = weekOffDatesForMonth;
              }
        
              console.log("punchTimings", punchTimings);
        
              if (attendanceData && typeof attendanceData === 'object') {
                const presentCount = Object.keys(attendanceData).filter((date) => {
                  const formattedDate = date.split('-');
                  const dateMonth = formattedDate[1]; // Extract month from date
                  const dateYear = formattedDate[0]; // Extract year from date
        
                  // Only check for the selected month and year
                  if (dateYear === selectedYear && dateMonth === selectedMonth) {
                    // Check if the status is "Full"
                    return attendanceData[date]?.status === 'Full';
                  }
                  return false;
                }).length;
        
                const halfDayCount = Object.keys(attendanceData).filter((date) => {
                  const formattedDate = date.split('-');
                  const dateMonth = formattedDate[1]; // Extract month from date
                  const dateYear = formattedDate[0]; // Extract year from date
        
                  // Only check for the selected month and year
                  if (dateYear === selectedYear && dateMonth === selectedMonth) {
                    // Check if the status is "Half"
                    return attendanceData[date]?.status === 'Half';
                  }
                  return false;
                }).length;
        
                const presentDays = Object.keys(attendanceData).filter((date) => {
                  const formattedDate = date.split('-');
                  const dateMonth = formattedDate[1]; // Extract month from date
                  const dateYear = formattedDate[0]; // Extract year from date
        
                  // Only check for the selected month and year
                  if (dateYear === selectedYear && dateMonth === selectedMonth) {
                    // If status is "Full", consider it a present day
                    return attendanceData[date]?.status === 'Full';
                  }
                  return false;
                });
        
                const halfDays = Object.keys(attendanceData).filter((date) => {
                  const formattedDate = date.split('-');
                  const dateMonth = formattedDate[1]; // Extract month from date
                  const dateYear = formattedDate[0]; // Extract year from date
        
                  // Only check for the selected month and year
                  if (dateYear === selectedYear && dateMonth === selectedMonth) {
                    // If status is "Half", consider it a half day
                    return attendanceData[date]?.status === 'Half';
                  }
                  return false;
                });
        
                const absentDays = Object.keys(attendanceData).filter((date) => {
                  const formattedDate = date.split('-');
                  const dateMonth = formattedDate[1]; // Extract month from date
                  const dateYear = formattedDate[0]; // Extract year from date
        
                  // Only check for the selected month and year
                  if (dateYear === selectedYear && dateMonth === selectedMonth) {
                    // If status is not "Full" or "Half", consider it an absent day
                    return attendanceData[date]?.status !== 'Full' && attendanceData[date]?.status !== 'Half';
                  }
                  return false;
                });
        
                // Format the absent days to show the date only
                const formattedAbsentDays = absentDays.map((date) => {
                  const formattedDate = date.split('-');
                  return `${formattedDate[2]}`;
                });
        
                console.log(`Absent dates: ${formattedAbsentDays.join(', ')}`);
        
                presentCountMap[mobile] = presentCount;
                halfDayCountMap[mobile] = halfDayCount;
                presentDayMap[mobile] = presentDays;
                halfDayCountMap1[mobile] = halfDays;
                absentDayMap[mobile] = formattedAbsentDays;
              }
            });
        
            // Calculate total days in the selected month
            const totalDays = new Date(selectedYear, selectedMonth, 0).getDate();
            const totalStaff =new Date
            // Calculate absent count
            const absentCount = totalDays - Object.values(presentCountMap).reduce((a, b) => a + b, 0) - Object.values(halfDayCountMap).reduce((a, b) => a + b, 0) - Object.values(weekOffCountMap).reduce((a, b) => a + b, 0);
        
            // setAbsentCountValue(absentCount);
        
            setAttendanceData(attendanceDataMap); 
            setPresentCountMap(presentCountMap); // Set the map for rendering
            setHalfDayCountMap(halfDayCountMap); // Set the map for rendering half-day counts
            setPresentDayMap(presentDayMap); // Set the map for rendering present days
            sethalfDayCountMap1(halfDayCountMap1); // Set the map for rendering half-day dates
            setWeekOffCountMap(weekOffCountMap); // Set the map for rendering week off counts
            setAbsentDayMap(absentDayMap); // Set the map for rendering absent days
          }
        };


  const fetchSchoolData = () => {
    const firebaseDatabaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`;
  console.log("firebaseDatabaseUrl",firebaseDatabaseUrl);
  
    fetch(firebaseDatabaseUrl)
      .then(response => response.json())
      .then(data => {
        setSchoolData(data); 
      })
      .catch(error => {
        console.error('Error fetching school data from Firebase:', error);
      });
  };

  useEffect(() => {
    if (employeeDetails.length > 0 && selectedMonth) {
      fetchAttendanceDataForMonth();
    }
  }, [employeeDetails, selectedMonth]);

  const handlePrint = () => {
    const printContent = document.querySelector('.modal-content');
    console.log("printContent",printContent);
  
    if (printContent) {
      const cloneContent = printContent.cloneNode(true);
  
      const schoolName = cloneContent.querySelector('p'); 
      const otherDetails = cloneContent.querySelectorAll('p'); 
  
      otherDetails.forEach((p, index) => {
        if (index !== 0) { 
          p.style.fontWeight = 'normal'; 
        }
      });
      
      if (schoolName) {
        schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`; 
      }
  
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Modal Content</title>
            <style>
              @page {
                size: landscape;
                margin: 3mm;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0; 
              }
              .modal-content {
                margin: 10px; 
              }
              thead {
                background-color: #F0F0F0; 
              }
              .title-print{
                padding-top:0;
              }
                .print-title{
                  width:300px;
                  height:34px;
                  padding-bottom:-20px;
                  text-align:center;
                }
            </style>
          </head>
          <body>
            ${cloneContent.outerHTML}
          </body>
        </html>
      `);
      printWindow.document.close(); 
      printWindow.focus();
      printWindow.print(); 
      printWindow.close(); 
    } else {
      console.error('Print content not found');
    }
  };

  const handleClose = () => {
    navigate(-1);
  };

  
  return (
    <div className='main-content-of-page'>
 
      <div
        className="attendance-staff-report-container"
        style={{
          maxWidth: '1200px',
          margin: '40px auto',
          padding: '20px',
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          fontFamily: 'Arial, sans-serif',
          border: '1px solid black',
          marginTop:'10px',
        }}
      >
        <button style={{ 
            backgroundColor: '#dc3545', 
            color: '#fff', 
            border: 'none', 
            borderRadius: '5px', 
            cursor: 'pointer', 
            fontSize: '20px', 
            marginLeft: '1120px',
            marginBottom:'10px',
            fontWeight:'bold',
          }} onClick={handleClose}> 
            X
          </button>
          
        <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center' }}>
          <label
            htmlFor="attendanceMonth"
            style={{ marginRight: '10px', fontSize: '18px', fontWeight: 'bold', color: 'black' }}
          >
           {language === "English" ? " Attendance Month : " : "उपस्थिती महिना:"}
          </label>
          <input
            type="month"
            id="attendanceMonth"
            value={selectedMonth}
            onChange={handleMonthChange}
            style={{
              padding: '5px',
              fontSize: '16px',
              borderRadius: '5px',
              border: '2px solid black',
              outline: 'none',
              cursor: 'pointer',
            }}
          />
           {/* Print Button */}
        <button
          style={{
            backgroundColor: '#1B4332',
            color: '#ffff',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginLeft:'700px',
          }}
          onClick={handlePrint}
        >
          Print
        </button>
        </div>

       <div className="modal-content"   style={{
          width: '98%', margin:'auto'}}>
          <table
            style={{ width:'98%', margin:'20px auto',
              borderCollapse: 'collapse',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              borderRadius: '2px',
              overflow: 'hidden', 
            }}
          >
             <thead>
                    {schoolData && (
                      <tr>
                        <th colSpan="12" style={{
                          color: 'black',
                          padding: '10px',
                          paddingTop: '17px',
                          borderRadius: '10px 10px 0 0',
                          textAlign: 'center',
                          lineHeight: '0.4',
                          border: '1px solid black',
                          fontSize: '13px', 
                        }}>
                          <p><strong><h5> {schoolData.schoolName}</h5></strong></p>
                          <p>{schoolData.sansthaName}</p>
                          <p>{language === "English" ? "Taluka:" : "तालुका:"} {schoolData.taluka} , {language === "English" ? "Jilha:" : "जिल्हा:"} {schoolData.jilha} </p>
                          <p>{language === "English" ? "Mobile Number:" : "मोबाइल नंबर:"} {schoolData.mobileNumber} , {language === "English" ? "Email:" : "ईमेल:"} {schoolData.email}</p>
                          <h1 className='print-title' style={{ paddingTop:'5px', height:'35px',margin:'auto',textAlign: 'center', color: '#143625', fontSize: '18px', marginBottom: '20px',border:'1px solid black',width:'240px',backgroundColor:'black',color:'white',borderRadius:'6px' }}>
                            {language === "English" ? "Staff Attendance Report" : "कर्मचारी उपस्थिती अहवाल"}
          </h1>
                        </th>
                      </tr>
                    )}
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Sr.No" : "अनु.क्र."}</th>
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Name" : "नाव"}</th>
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Mobile Number" : "मोबाईल नंबर"}</th>
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Address" : "पत्ता"}</th>
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Present" : "उपस्थित"}</th>
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Half" : "अर्धा दिवस"}</th>
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Absent" : "अनुपस्थित"}</th>
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Week Off" : "आठवडा सुट्टी"}</th>
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Present Day" : "उपस्थित दिवस"}</th>
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Half Day" : "अर्धा दिवस"}</th>
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Absent Day" : "अनुपस्थित दिवस"}</th>
                <th style={{ padding: '5px', textAlign: 'center',border: '1px solid black',backgroundColor: '#ecf0f1',color: 'black' }}>{language === "English" ? "Week Off Day" : "आठवडा सुट्टीचे दिवस"}</th>
            </thead>
          <tbody>
  {employeeDetails.length > 0 ? (
    employeeDetails.map((employee, index) => {
      const attendance = attendanceData[employee.mobile] || {};
      return (
        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff' }}>
          <td style={{ padding: '5px', border: '1px solid black' }}>{index + 1}</td>
          <td style={{ padding: '10px', border: '1px solid black' }}>{employee.name}</td>
          <td style={{ padding: '10px', border: '1px solid black' }}>{employee.mobile}</td>
          <td style={{ padding: '10px', border: '1px solid black' }}>{employee.address}</td>
          <td style={{ padding: '10px', border: '1px solid black' }}>
            {presentCountMap[employee.mobile] || 0}
          </td>
          <td style={{ padding: '10px', border: '1px solid black' }}>
            {halfDayCountMap[employee.mobile] || 0}
          </td>
          <td style={{ padding: '10px', border: '1px solid black' }}>
          {absentCountValue}
          </td>
          <td style={{ padding: '10px', border: '1px solid black' }}>
          {weekOffDaysCount}
          </td>
          <td style={{ padding: '10px', border: '1px solid black' }}>
            {presentDayMap[employee.mobile] ? presentDayMap[employee.mobile].map(date => date.split('-').slice(2)).join(', ') : '-'}
          </td>
          <td style={{ padding: '10px', border: '1px solid black' }}>
            {halfDayCountMap1[employee.mobile] ? halfDayCountMap1[employee.mobile].map(date => date.split('-').slice(2)).join(', ') : '-'}
          </td>
          <td style={{ padding: '10px', border: '1px solid black' }}>
    {absentdates.filter((adate) => !weekOffDates.includes(parseInt(adate.split('-')[2]))).map((adate, index) => (
      <span key={index}>{adate.split('-')[2]}, </span>
    ))}
</td>
          <td style={{ padding: '10px', border: '1px solid black' }}>
            {weekOffDates.join(', ')}
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="12" style={{ textAlign: 'center', padding: '20px', borderBottom: '1px solid #e0e0e0' }}>
        No employee details found.
      </td>
    </tr>
  )}
</tbody>
    </table>
        </div>
      </div>
    </div>
  );
}
export default AttendanceStaffReport;